export const prefix = 'yjy-fitness';
